<template>
  <b-col 
    class="px-4 mt-5 mx-auto" 
    cols="12" md="10" lg='8'
  >
    <form 
      class="change-mail-form p-2 m-2"
      @submit.prevent="deleteAccount"
      novalidate
    >
      <h4 class="mb-3 form-header">{{'userProfileDeleteHeader' | localize}}:</h4>
      <div class=" mt-5 mb-4 delete-profile-description">
        {{'userProfileDeleteDescription' | localize}}
      </div>
      <input
          type="password"
          class="form-control"
          v-model="user_password"
      >
      <div
          class="form-description-error"
          v-if="$v.new_user_password.$dirty && !$v.new_user_password.required"
      >
        {{'newAddressRequiredInput' | localize}}
      </div>
      <div
          class="form-description-error"
          v-if="$v.new_user_password.$dirty && !$v.new_user_password.minLength"
      >
        {{'userProfileMinSymbols' | localize}}
      </div>
      <b-button
        class="mt-5 mb-0 style-button button-profile-width"
        type="submit"
        variant="outline-danger"
      >
        {{'userProfileDeleteButton' | localize}} 
        <div class="style-button-icon"> 
          <b-icon  icon="trash" ></b-icon> 
        </div> 
      </b-button>
    </form>
  </b-col>  
</template>
<script>
import { mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
import base64url from "base64url";
export default {
  mixins: [validationMixin],
  data: ()=> ({
    user_password: '',
  }),
  validations: {
    new_user_password: {required, minLength: minLength(8)},
    confirm_new_user_password: {sameAs: sameAs('new_user_password')},
  },
  computed: mapGetters(['userInfoData', 'locale']),
  methods: {
    async deleteAccount(){
      if(base64url.decode(localStorage.weltumPass ) === this.user_password) {
        await this.$store.dispatch('deleteProfile')
        this.$messageLocalized("profileDeleted").then(() => {
          localStorage.removeItem('weltumAuth')
          this.$store.dispatch('logout')
          this.$router.push({path: '/login'})
        })
      } else {
        this.$messageLocalized('wrongPassword')
      }
    }
  },
}
</script>